<mat-sidenav-container>
  <mat-sidenav #sidenav mode="over" class="w-full lg:w-1/2 xl:w-1/3 bg-white max-h-screen" [autoFocus]="false">
    <lohi-menu (closeMenu)="sidenav.close()"></lohi-menu>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="flex flex-col h-screen">
      <ng-container *lohiIsAdmin>
        <ng-container *ngIf="showCommitmentBar$ | async">
          <a
            routerLink="/"
            class="bg-red-500 text-white text-center no-print"
            *ngIf="(regionsNotMeetingCommitment$ | async)?.length as length"
          >
            <ng-container *ngIf="length === 1">
              Add drivers to meet your commitment for the
              <span class="font-bold">{{ (regionsNotMeetingCommitment$ | async)[0] }}</span> region
            </ng-container>
            <ng-container *ngIf="length > 1">
              Add drivers to meet your commitments for
              <span class="font-bold">{{ regionsNotMeetingCommitment$ | async | joinWithAnd }}</span> regions
            </ng-container>
          </a>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!isV2Dashboard && !isFinalCount">
        <ng-container *ngIf="showTitleBar$ | async">
          <ng-container *ngIf="bannerMessage$ | async as banner">
            <div
              class="bg-blue-300 text-gray-700 text-center no-print py-1"
              [style.backgroundColor]="banner.backgroundColor"
              [style.color]="banner.textColor"
            >
              <span class="font-bold">{{ banner.text }}</span>
            </div>
          </ng-container>
          <div class="h-6 flex bg-white no-print" style="min-height: 48px">
            <div class="ml-2 flex items-center justify-center">
              <mat-icon class="cursor-pointer" (click)="sidenav.open()">menu</mat-icon>
              <div class="ml-1">LoHi Logistics</div>
            </div>
            <div class="flex-1 flex items-center justify-center">
              <a [routerLink]="['/']">
                <img [src]="logo$ | async" alt="lohi logo" class="h-5" />
              </a>
            </div>
            <div class="flex items-center justify-center mr-1" *lohiIsAdmin>
              <a
                *lohiFeatureFlag="'v2Dashboard'"
                href="/v2/dashboard"
                class="p-1 mr-2 bg-blue-500 text-white rounded-md"
                >Try V2</a
              >
            </div>
            <div class="flex items-center justify-center mr-1" *lohiIsAdmin>
              <span class="mr-2">{{ carrierName$ | async }}</span>
              <button mat-icon-button tooltip="Company Settings" (click)="promptSettingsChange()">
                <mat-icon>settings</mat-icon>
              </button>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <div class="flex-1 print:block" style="break-inside: avoid">
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<lohi-company-suspension-banner></lohi-company-suspension-banner>
<lohi-versioning></lohi-versioning>
<lohi-api-indicator
  *ngIf="!env.production"
  class="fixed top-0 h-6 no-print"
  style="z-index: 10000; width: 150px; left: 50px"
></lohi-api-indicator>

<ng-template #settingsModal>
  <div mat-dialog-title>
    <div class="flex justify-between">
      <div>Company Settings</div>
      <div>
        <mat-icon class="cursor-pointer" mat-dialog-close>close</mat-icon>
      </div>
    </div>
  </div>
  <form mat-dialog-content [formGroup]="companySettingsForm" autocomplete="off">
    <div class="grid lg:grid-cols-2 gap-3">
      <div>
        <div class="flex flex-col">
          <div class="text-lg font-bold pb-2">Driver Earnings Settings</div>
          <mat-form-field>
            <mat-label>Driver Earnings Percentage</mat-label>
            <input matInput formControlName="defaultDriverCut" type="number" />
            <div matSuffix>%</div>
          </mat-form-field>
          <div class="text-gray-700 text-sm">
            The default % of a load's line-haul which a driver can expect to earn. This can be overridden for individual
            drivers when inviting them.
          </div>
          <div>
            <button (click)="updateDefaultPercentage()" color="primary" mat-stroked-button>Submit</button>
          </div>
        </div>
      </div>
    </div>
    <div class="h-2"></div>
    <mat-divider></mat-divider>
    <div class="h-2"></div>
    <div class="flex flex-col">
      <mat-checkbox
        *lohiRelationship="'saas'"
        color="primary"
        class="mt-2"
        formControlName="allowDriverBooking"
        (change)="updateAllowDriverShiftBooking()"
        >Allow Drivers to Book Shifts</mat-checkbox
      >
      <ng-container *lohiFeatureFlag="'assetManagement'">
        <mat-checkbox
          color="primary"
          class="mt-2"
          formControlName="allowDriverTruckCreate"
          (change)="updateAllowDriverTruckCreation()"
          >Allow Drivers to Create Trucks</mat-checkbox
        >
        <mat-checkbox
          color="primary"
          class="mt-2"
          formControlName="allowDriverTrailerCreate"
          (change)="updateAllowDriverTrailerCreation()"
          >Allow Drivers to Create Trailers</mat-checkbox
        >
      </ng-container>
      <ng-container *ngIf="enableTours$ | async">
        <mat-checkbox
          color="primary"
          class="mt-2"
          formControlName="allowDriversToViewTourDollarAmounts"
          (change)="updateAllowDriversToViewTourDollarAmounts()"
          >Allow Drivers to View Tour Dollar Values</mat-checkbox
        >
        <mat-checkbox
          color="primary"
          class="mt-2"
          formControlName="allowDriversToReviewRateCon"
          (change)="updateAllowDriversToViewTourRateCon()"
          >Allow Drivers to View Tour RateCon</mat-checkbox
        >
        <mat-checkbox
          color="primary"
          class="mt-2"
          formControlName="allowDriversToApproveTours"
          (change)="updateAllowDriversToApproveTours()"
          >Allow Drivers to Approve or Decline Tours</mat-checkbox
        >
      </ng-container>
    </div>
    <div class="h-2"></div>
    <mat-divider></mat-divider>
    <div class="h-2"></div>
    <div class="flex justify-between" mat-mat-dialog-actions>
      <button type="button" mat-flat-button matDialogClose>Close</button>
    </div>
  </form>
</ng-template>
